module.exports = __webpack_public_path__ + "img/EC_botellas.f1603b4d.png";